export default "__VITE_ASSET__CTp$S0tR__"